/**
 * The HOC is used to add extra actions to original Tag component.
 * @author: Ronan
 * @param: targetProp {string} prop that passed to WrappedComponent
 * @example: Tags in dropzones of the Report Setup Filters.
 */
import { Checkbox, Dropdown, Icon, Menu } from 'antd';
import React, { PureComponent } from 'react';
import Enums from 'utils/EnumsManager';
import { FormattedMessage } from 'react-intl';

const CheckboxGroup = Checkbox.Group;
const { Item } = Menu;
const { REPORTS, DROPZONES, FieldTypes } = Enums;
const { DateOnly, DateTime } = FieldTypes;
const { AGGREGATES, GROUPS } = DROPZONES;
const { GROUPS_ZONE_TAG_ACTIONS, AGGREGATES_ZONE_TAG_ACTIONS } = REPORTS;

const addActions = targetProp => WrappedComponent =>
  class extends PureComponent {
    handleCheckboxChange = checkedValues =>
      this.props.setActions(this.props.id, checkedValues);
    // Notes: When dropdown trigger includes click, click on menu will also call this function with key 'undefined'.
    //        So we need to skip it.
    handleClick = ({ key }) => {
      if (key) {
        this.props.setActions(this.props.id, key);
      }
    };

    renderGroupsMenu = () => {
      const i18n = 'page.ReportTableSetup.actions';
      return (
        <Menu onClick={this.handleClick} selectedKeys={[this.props.actions]}>
          {GROUPS_ZONE_TAG_ACTIONS.map(action => (
            <Item key={action}>
              <FormattedMessage id={`${i18n}.${action}`} />
            </Item>
          ))}
        </Menu>
      );
    };

    renderAggregatesMenu = () => {
      const i18n = 'page.ReportTableSetup.actions';
      const options = AGGREGATES_ZONE_TAG_ACTIONS.map(action => ({
        label: <FormattedMessage id={`${i18n}.${action}`} />,
        value: action
      }));
      return (
        <Menu onClick={this.handleClick}>
          <CheckboxGroup
            options={options}
            onChange={this.handleCheckboxChange}
            className="vertical"
            value={this.props.actions}
          />
        </Menu>
      );
    };

    renderMenuByZone = zone => {
      switch (zone) {
        case GROUPS:
          return this.renderGroupsMenu();
        case AGGREGATES:
          return this.renderAggregatesMenu();
        default:
          return null;
      }
    };

    renderMenu = () => {
      const { belongTo, type } = this.props;
      if ([AGGREGATES, GROUPS].indexOf(belongTo) < 0) {
        return null;
      }
      if (belongTo === GROUPS && (type !== DateOnly && type !== DateTime)) {
        return null;
      }

      return (
        <Dropdown trigger={['click']} overlay={this.renderMenuByZone(belongTo)}>
          <Icon
            type="ellipsis"
            onClick={this.handleClick}
            style={{
              margin: '0 0 0 5px',
              transform: 'rotate(90deg)',
              position: 'absolute',
              right: 0,
              top: 4
            }}
          />
        </Dropdown>
      );
    };

    render() {
      const extraProp = {
        [targetProp]: this.renderMenu()
      };

      return <WrappedComponent {...this.props} {...extraProp} />;
    }
  };

export default addActions;



// WEBPACK FOOTER //
// ./src/components/hoc/addActions.jsx